import { Sun, Moon } from 'lucide-react';
import { useThemeStore } from '@/stores/theme';
import { cn } from '@/utils';

type Props = { className?: string };

export function ThemeToggle({ className }: Props) {
  const theme = useThemeStore((s) => s.theme);
  const toggleTheme = useThemeStore((s) => s.toggleTheme);
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      aria-label="Toggle dark mode"
      onClick={toggleTheme}
      className={cn(
        'inline-flex items-center gap-2 rounded-md border px-3 py-1.5 text-sm transition-colors',
        isDark
          ? 'bg-gray-800 text-gray-100 border-gray-700 hover:bg-gray-700'
          : 'bg-white text-gray-800 border-gray-200 hover:bg-gray-100',
        className
      )}
    >
      {isDark ? <Moon size={16} /> : <Sun size={16} />}
      <span>{isDark ? 'Dark' : 'Light'}</span>
    </button>
  );
}